// Allows a word containing a character at start with
// 0 or more characters, digits, underscore(_), and dash(-)
// that when a special character is found, it should be followed immediately with a character or digit
// and ends with a character or a digit at the end.
// i.e. good = good_food, another-food2  bad= go_go_ , -go, go--go
export const isValidUsername = (input: string) =>
  input != null &&
  typeof input === 'string' &&
  /^([A-Za-z]+[A-Za-z0-9]*)([\_\-]{1}[A-Za-z0-9]+)*$/gi.test(input.trim());

export const isAtMax = (len: number) => (input: string) => typeof input === 'string' && input.length <= len;
